import { Badge } from "react-bootstrap";

import Loader from "components/ui/Loader";
import { localizeDate } from "utils/DateUtils";
import ErrorHandler from "components/ui/ErrorHandler";
import EmptyStateHandler from "components/ui/EmptyStateHandler";
import RoleBadge from "features/account/components/ui/RoleBadge";

import MemberUpdate from "./MemberUpdate";
import MemberDelete from "./MemberDelete";
import ResendInvitation from "./ResendInvitation";

const MemberListItem = ({
  error,
  isLoading,
  members,
  handleMemberUpdated,
  handleMemberDeleted,
}) => {
  if (isLoading) {
    return (
      <tr>
        <td colSpan={8}>
          <Loader />
        </td>
      </tr>
    );
  }
  if (error) {
    return (
      <tr>
        <td colSpan={8}>
          <ErrorHandler error={error} />
        </td>
      </tr>
    );
  }

  if (!members) return <></>;

  if (!members.length)
    return (
      <tr>
        <td colSpan={8}>
          <EmptyStateHandler
            title="No account members"
            description="Account members will appear here once added"
          />
        </td>
      </tr>
    );

  return members.map((subscriber) => {
    return (
      <tr key={subscriber.subscriberId}>
        <td>{subscriber.firstName}</td>
        <td>{subscriber.lastName}</td>
        <td>{subscriber.email}</td>
        <td>
          <RoleBadge role={subscriber.invitation.role} />
        </td>
        <td>{subscriber.facilitiesCount}</td>
        <td>
          {subscriber?.invitation?.subscriberJoinedAt ? (
            <small>
              {localizeDate(subscriber?.invitation?.subscriberJoinedAt)}
            </small>
          ) : (
            <Badge
              bg="warning"
              className="p-1 px-2 bg-warning bg-opacity-10 text-warning"
            >
              Pending Invitation
            </Badge>
          )}
        </td>
        <td>
          <small>{localizeDate(subscriber.updatedAt)}</small>
        </td>
        <td>
          <span className="d-flex">
            <ResendInvitation subscriber={subscriber} />
            <MemberUpdate
              member={subscriber}
              onMemberUpdated={handleMemberUpdated}
            />{" "}
            <MemberDelete
              member={subscriber}
              onMemberDeleted={handleMemberDeleted}
            />
          </span>
        </td>
      </tr>
    );
  });
};

export default MemberListItem;
